import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Login/Login";
import SignUp from "./SignUp/SignUp";
import FillInformation from "./FillInformation/FillInformation";
import Home from "./Pages/Home/Home";
import Event from "./Pages/Event/Event";
import Committee from "./Pages/Committee/Committee";
import Blog from "./Pages/Blog/Blog";
import Gallery from "./Pages/Gallery/Gallery";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Profile from "./Profile/Profile";
import { UserProvider } from "./FillInformation/UserContext";
import ConnectionsPage from "./Profile/ConnectionPage";
import Notice from "./Pages/Notice/Notice";
import Courses from "./Pages/Courses/Courses";
import GraduateCourseDetails from "./Pages/GraduateCourseDetails";
import PostById from "./Pages/PostById";
import PostGraduateCourseDetails from "./Pages/PostGraduateCourseDetails";
import AdmissionDetails from "./Pages/AdmissionDetails/AdmissionDetails";
import { SearchProvider } from "./Context/SearchContext";
import { NotificationProvider } from "./Context/NotificationContext";
import PrivateRoute from "./Utils/PrivateRoute";
import MainLayout from "./Utils/MainLayout";
import Chat from "./Pages/Chat/Chat";
import NotificationPage from "./Pages/Notifications/Notifications";


function App() {
	return (
		<div>
			<UserProvider>
				<SearchProvider>
					{/* <NotificationProvider> */}
					<BrowserRouter>
						<Routes>
							<Route path="/login" element={<Login />} />
							<Route path="/signup" element={<SignUp />} />
							<Route
								path="/fill-information"
								element={<FillInformation />}
							/>
							<Route element={<PrivateRoute />}>
								<Route element={<MainLayout />}>
									<Route path="/" element={<Home />} />
									<Route path="/home" element={<Home />} />
									<Route path="/event" element={<Event />} />
									<Route
										path="/committee"
										element={<Committee />}
									/>
									<Route path="/blog" element={<Blog />} />
									<Route
										path="/gallery"
										element={<Gallery />}
									/>
									<Route
										path="/about"
										element={<AboutUs />}
									/>
									<Route
										path="/profile"
										element={<Profile />}
									/>
									<Route
										path="/connections"
										element={<ConnectionsPage />}
									/>
									<Route
										path="/notice"
										element={<Notice />}
									/>
									<Route
										path="/courses"
										element={<Courses />}
									/>
									<Route
										path="/graduate-course-details/:id"
										element={<GraduateCourseDetails />}
									/>
									<Route
										path="/postgraduate-course-details/:id"
										element={<PostGraduateCourseDetails />}
									/>
									<Route
										path="/admission-details/:id"
										element={<AdmissionDetails />}
									/>
									<Route
										path="/posts/:id"
										element={<PostById />}
									/>
									<Route>
										{/* other routes */}
										<Route path="/chat/:id" element={<Chat />} />
									</Route>
									<Route path="/notifications" element={<NotificationPage />} />
								</Route>
							</Route>
						</Routes>
					</BrowserRouter>
					{/* </NotificationProvider> */}
				</SearchProvider>
			</UserProvider>
		</div>
	);
}

export default App;

// import React from "react";
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// // import { UserProvider } from './UserContext'; // Import the UserProvider
// import Login from './Login/Login';
// import SignUp from './SignUp/SignUp';
// import FillInformation from './FillInformation/FillInformation';
// import Home from './Pages/Home/Home';
// import Event from './Pages/Event/Event';
// import Committee from './Pages/Committee/Committee';
// import Blog from './Pages/Blog/Blog';
// import Gallery from './Pages/Gallery/Gallery';
// import AboutUs from './Pages/AboutUs/AboutUs';
// import Profile from './Profile/Profile';
// import { UserProvider } from "./FillInformation/UserContext";
// import ConnectionsPage from "./Profile/ConnectionPage";
// import Notice from "./Pages/Notice/Notice";
// import Courses from "./Pages/Courses/Courses";
// import PostById from "./Pages/PostById";

// function App() {
//   return (
//     <div>
//       <UserProvider>
//         <BrowserRouter>
//           <Routes>
//             <Route path='/login' Component={Login} />
//             <Route path='/signup' Component={SignUp} />
//             <Route path='/fill-information' Component={FillInformation} />
//             <Route path='/' Component={Home} />
//             <Route path='/home' Component={Home} />
//             <Route path='/event' Component={Event} />
//             <Route path=""/>
//             <Route path='/committee' Component={Committee} />
//             <Route path='/blog' Component={Blog} />
//             <Route path='/gallery' Component={Gallery} />
//             <Route path='/about' Component={AboutUs} />
//             <Route path='/profile' Component={Profile} />
//             <Route path='/connections' Component={ConnectionsPage} />
//             <Route path='/notice' Component={Notice} />
//             <Route path="/courses" Component={Courses}/>
//             <Route path="/posts/:id" Component={PostById} />
//           </Routes>
//         </BrowserRouter>
//       </UserProvider>
//     </div>
//   );
// }

// export default App;
